export const PROJECT_LIST_QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
} as const;
